import { render, staticRenderFns } from "./EWUserLimitConfigForm.vue?vue&type=template&id=6f9f6afe&"
import script from "./EWUserLimitConfigForm.vue?vue&type=script&lang=js&"
export * from "./EWUserLimitConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports